import Vue from "vue";
import VueRouter from "vue-router";
import Login from "@/components/auth/pages/Login.vue";
import Logout from "@/components/auth/pages/Logout.vue";
import AdminTop from "@/components/config/pages/AdminTop.vue";

import { auth } from "@/libs";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "login",
    component: Login,
  },
  {
    path: "/logout",
    name: "logout",
    component: Logout,
  },
  {
    path: "/admin",
    name: "admin",
    component: AdminTop,
    meta: { requiresAuth: true, admin: true },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  if (requiresAuth) {
    auth.onAuthStateChanged(function (user) {
      if (user) {
        next();
      } else {
        next({
          path: "/",
        });
      }
    });
  } else {
    next();
  }
});

export default router;
